import React from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

const Intro = () => {
  const navigate = useNavigate();

  const startQuiz = () => {
    navigate("/eventOldQuiz/main");
  };

  return (
    <IntroContainer>
      <IntroImg src="/images/sinor_event_intro.jpg" />
      <IntroBtn onClick={startQuiz}>
        <Quiz>
          퀴즈 풀러 가기 <Go>Go</Go>
        </Quiz>
      </IntroBtn>
      <PointImg src="/images/points.png" />
    </IntroContainer>
  );
};

export default Intro;

const IntroContainer = styled.div`
  position: relative;
  width: 1000px;
  margin: 0 auto;

  @media screen and (max-width: 1000px) {
    width: 100vw;
  }
`;

const IntroImg = styled.img`
  display: block;
  width: 100%;
`;

const PointImg = styled.img`
  position: absolute;
  right: 10%;
  bottom: 10%;
  width: 20%;
`;

const IntroBtn = styled.button`
  ${props => props.theme.variables.flex("", "center", "center")};
  color: ${props => props.theme.style.darkBlue};
  background-color: ${props => props.theme.style.white};
  border-radius: ${props => props.theme.style.borderRadius};
  font-family: ${props => props.theme.style.yangjin};
  position: absolute;
  left: 50%;
  bottom: 20%;
  transform: translateX(-50%);
  width: 55%;
  height: 15%;
  outline: none;
  border: none;
  font-size: 3rem;
  transition: all 500ms ease;

  &:hover {
    box-shadow: 10px 10px 25px 10px rgba(0, 0, 0, 0.3);
  }

  @media screen and (max-width: 900px) {
    font-size: 2.5rem;
  }

  @media screen and (max-width: 700px) {
    font-size: 2rem;
  }

  @media screen and (max-width: 500px) {
    font-size: 1.5rem;
  }

  @media screen and (max-width: 400px) {
    font-size: 1rem;
  }

  @media screen and (max-width: 300px) {
    font-size: 0.8rem;
  }
`;

const Quiz = styled.div`
  color: ${props => props.theme.style.darkBlue};
  transition: all 500ms ease;
  font-size: 1em;
  margin-top: 2px;
`;

const Go = styled.span`
  color: ${props => props.theme.style.red};
`;
